import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp, ChevronLeft, ChevronRight } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';

const ProofSection = () => {
  const [api, setApi] = useState();

  const testimonials = [
    {
      id: 1,
      videoUrl: "/video-testimonial-1.mp4",
      headline: "Panduan Ka Arep Bikin Trading Jadi Lebih Pasti!",
      subheadline: "GILAAAA!! Guna Indikator SBE bisa grow akun dengan konsisten. Hasil nyata dari pengguna Indikator SBE dan konsisten follow arahan Arep",
      highlightText: "Panduan Ka Arep"
    },
    {
      id: 2,
      videoUrl: "/video-testimonial-2.mp4",
      headline: "Hasil Gila dengan Kombinasi Signal & Indikator SBE!",
      subheadline: "Profit konsisten walaupun lot kecil, sinyal dan zona entry jelas bikin trading lebih yakin! Ini feedback asli dari pengguna setia Indikator SBE.",
      highlightText: "Hasil Gila"
    },
    {
      id: 3,
      videoUrl: "/video-testimonial-3.mp4",
      headline: "Dari Modal Kecil ke Profit Konsisten: Sinyal dan SBE Bikin Trading Lebih Menguntungkan!",
      subheadline: "Cuma dengan konfirmasi dari Indikator SBE, saldo akun udah bisa grow 50% dari modal! Ini feedback terus dari user Indikator SBE",
      highlightText: "50%"
    }
  ];

  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 bg-[#ED1C24]/10 border border-[#ED1C24]/30 rounded-full px-6 py-3 mb-6">
              <TrendingUp className="w-5 h-5 text-[#ED1C24]" />
              <span className="text-[#ED1C24] font-bold">PROVEN STRATEGY</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Nahh kalian liat sendiri gimana{' '}
              <span className="text-[#ED1C24]">student Arep bisa cuan</span>{' '}
              cuman dengan Indikator SBE
            </h2>
            <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">
              Hasil nyata dari trader yang konsisten pakai Indikator SBE dan ikuti arahan Arep
            </p>
          </div>
          
          <Carousel 
            className="w-full max-w-6xl mx-auto relative"
            setApi={setApi}
            opts={{
              align: "center",
              loop: true,
            }}
          >
            <CarouselContent>
              {testimonials.map((testimonial) => (
                <CarouselItem key={testimonial.id}>
                  <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center px-4 md:px-8 lg:px-12">
                    <div className="bg-gradient-to-br from-[#1a1a1a] to-black rounded-2xl p-1.5 md:p-2 border border-gray-800 relative">
                      <div className="w-full max-w-[280px] md:max-w-md mx-auto" style={{ aspectRatio: '9/16' }}>
                        <video
                          src={testimonial.videoUrl}
                          className="w-full h-full rounded-xl object-cover"
                          controls
                          playsInline
                        />
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-3xl md:text-4xl font-bold mb-6">
                        {testimonial.id === 1 ? (
                          <>
                            <span className="text-[#ED1C24]">Panduan Ka Arep</span>{' '}
                            Bikin Trading Jadi Lebih Pasti!
                          </>
                        ) : testimonial.id === 2 ? (
                          <>
                            <span className="text-[#ED1C24]">Hasil Gila</span> dengan Kombinasi Signal & Indikator SBE!
                          </>
                        ) : (
                          <>
                            Dari Modal Kecil ke Profit Konsisten:{' '}
                            <span className="text-[#ED1C24]">Sinyal dan SBE</span>{' '}
                            Bikin Trading Lebih Menguntungkan!
                          </>
                        )}
                      </h3>
                      <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
                        {testimonial.subheadline}
                      </p>
                      
                      {/* Mobile buttons - below subheadline */}
                      <div className="flex items-center justify-center gap-4 mt-8 md:hidden">
                        <button
                          onClick={() => api?.scrollPrev()}
                          className="bg-[#ED1C24] hover:bg-[#c91820] text-white border-0 w-12 h-12 rounded-full flex items-center justify-center transition-colors"
                          aria-label="Previous slide"
                        >
                          <ChevronLeft className="w-6 h-6" />
                        </button>
                        <button
                          onClick={() => api?.scrollNext()}
                          className="bg-[#ED1C24] hover:bg-[#c91820] text-white border-0 w-12 h-12 rounded-full flex items-center justify-center transition-colors"
                          aria-label="Next slide"
                        >
                          <ChevronRight className="w-6 h-6" />
                        </button>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            {/* Desktop buttons only */}
            <CarouselPrevious className="hidden md:flex left-0 lg:-left-4 xl:-translate-x-12 top-1/2 -translate-y-1/2 bg-[#ED1C24] hover:bg-[#c91820] text-white border-0 w-12 h-12 rounded-full z-10" />
            <CarouselNext className="hidden md:flex right-0 lg:-right-4 xl:translate-x-12 top-1/2 -translate-y-1/2 bg-[#ED1C24] hover:bg-[#c91820] text-white border-0 w-12 h-12 rounded-full z-10" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default ProofSection;